import { h } from 'preact';
import { Link } from 'preact-router/match';
import style from './style';

const Header = () => (
	<div class={style.header}>
		<div class="logoC">
		<Link activeClassName={style.active} href="/">		
		<img src="https://cdn.shopify.com/s/files/1/1120/3842/files/pigface.png?24"/>
		</Link>
	
		</div>
	<nav>
			
			<Link activeClassName={style.active} href="/ff">Shop</Link>
			<Link activeClassName={style.active} href="/info">Info</Link>

			<br/><br/>
			{/* <small>these are not the wholesale prices*<br/> — prices based off similar single shirt market retail prices. </small> */}
		</nav>
	</div>
);

export default Header;



// WEBPACK FOOTER //
// ./components/header/index.js